import { graphql } from '../../gql';

// The legacy ("V2") skill selection lists (skill_k75 / k700 / k3000). This is
// all that remains of the old SelectionList query: it is fetched at runtime only
// by DataBuilder's useSkillSelectionLists — the V2 counterpart to the skill
// taxonomy tree, mirroring ROLE_V2_SELECTION_LIST_QUERY for roles. RICS,
// geography and demographics now come from the taxonomyTree + reference lists,
// so they are no longer selected here.
export const SKILL_V2_SELECTION_LIST_QUERY = graphql(`
  query SkillV2SelectionList {
    selectionList {
      skill_k75 {
        id
        shortName
        longName
        topSkills
      }
      skill_k700 {
        id
        shortName
        longName
        skill_k75
        topSkills
      }
      skill_k3000 {
        id
        shortName
        longName
        skill_k75
        skill_k700
        topSkills
      }
    }
  }
`);
